import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageSkeleton } from "../../components/accommodation/page-skeleton";
import { RoomingView } from "../../components/accommodation/rooming";
import { canManageAccommodation, canSeeHostAccommodation } from "../../lib/accommodation/access";
import { useDefaultGamesId } from "../../lib/competition/games";

/** Rooming (her `#/acc/rooming`): the host's contingent table. Admins and OPERATION with `accommodation.*`. */
export const Route = createFileRoute("/_app/accommodation/rooming/")({
	beforeLoad: ({ context }) => {
		if (!canSeeHostAccommodation(context.session)) throw redirect({ to: "/accommodation" });
	},
	component: RoomingPage,
});

function RoomingPage() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId) return <PageSkeleton />;
	return <RoomingView gamesId={gamesId} canManage={canManageAccommodation(session)} />;
}
